import { createEntitySlice } from '@/shared/store/createEntitySlice';
import type { AuditLog, AuditLogFilters } from '@/shared/types/auditLog';
import { auditLogsApi } from '../api';

const initialState = {
  items: [] as AuditLog[],
  loading: false,
  error: null as string | null,
  currentPage: 1,
  perPage: 20,
  total: 0,
  lastPage: 1,
  filters: {
    search: '',
    dateRange: null,
    entityType: '',
    action: '',
  } as AuditLogFilters,
};

const { actions, reducer } = createEntitySlice<AuditLog, AuditLogFilters, never>({
  name: 'auditLogsEntity',
  api: auditLogsApi,
  initialState,
  getListParams: (state) => {
    const { currentPage, perPage, filters } = state.auditLogsEntity;
    const params: Record<string, unknown> = { page: currentPage, perPage };

    if (filters.search) {
      params.user = filters.search;
    }

    if (filters.entityType) {
      params.entityType = filters.entityType;
    }

    if (filters.action) {
      params.action = filters.action;
    }

    if (filters.dateRange?.start) {
      params.dateFrom = filters.dateRange.start;
    }

    if (filters.dateRange?.end) {
      params.dateTo = filters.dateRange.end;
    }

    return params;
  },
});

export const {
  fetchItems: fetchAuditLogs,
  createItem: createAuditLog,
  updateItem: updateAuditLog,
  deleteItem: deleteAuditLog,
  setPage: setAuditLogsPage,
  setPerPage: setAuditLogsPerPage,
  setFilters: setAuditLogsFilters,
} = actions;

export const auditLogsReducer = reducer;
